import { AUTH_TOKEN, AUTH_REFRESH_TOKEN, PERSIST_MODE, USED_ID } from '../constants'

export const useAuthorization = () => {
  const getAuthToken = () => sessionStorage.getItem(AUTH_TOKEN) || localStorage.getItem(AUTH_TOKEN)

  const getUserInfo = () => {
    const token = getAuthToken()
    if (token) {
      try {
        return JSON.parse(window.atob(token.split('.')[1]))
      } catch (err) {
        console.log(err)
      }
    }
  }

  const setAuthTokens = ({ dashboardAuthToken, dashboardRefreshToken, persistMode }) => {
    localStorage.setItem(PERSIST_MODE, +persistMode ? 1 : 0)
    if (dashboardAuthToken) {
      persistMode ? localStorage.setItem(AUTH_TOKEN, dashboardAuthToken) : sessionStorage.setItem(AUTH_TOKEN, dashboardAuthToken)
    }
    if (dashboardRefreshToken) {
      persistMode
        ? localStorage.setItem(AUTH_REFRESH_TOKEN, dashboardRefreshToken)
        : sessionStorage.setItem(AUTH_REFRESH_TOKEN, dashboardRefreshToken)
    }
  }

  const clearAuthTokens = () => {
    localStorage.removeItem(AUTH_TOKEN)
    sessionStorage.removeItem(AUTH_TOKEN)
    localStorage.removeItem(AUTH_REFRESH_TOKEN)
    sessionStorage.removeItem(AUTH_REFRESH_TOKEN)
    localStorage.removeItem(PERSIST_MODE)
    localStorage.removeItem(USED_ID)
  }

  const userId = localStorage.getItem(USED_ID) || ''

  return [getAuthToken, setAuthTokens, getUserInfo, clearAuthTokens, userId]
}
